import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from '@app/store/utils/baseQueryWithReauth';
import { ApiResponse } from '@app/store/utils/common';
import { extractData } from '@app/store/utils/common';
import {
  CardContent,
  DailyTipContent,
  ArcanaContent,
  ContentTagType,
} from '@app/store/slices/content/contentTypes';

export const contentApi = createApi({
  reducerPath: 'contentApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: Object.values(ContentTagType),
  endpoints: (builder) => ({
    getCardContent: builder.query<ApiResponse<CardContent>, string>({
      query: (cardId) => `/content/card/${cardId}`,
      providesTags: [ContentTagType.CARD],
    }),
    getRandomCardsContent: builder.query<CardContent | null, void>({
      query: () => '/content/cards/random',
      transformResponse: extractData,
      providesTags: [ContentTagType.RANDOM_CARDS],
    }),
    getDailyTipContent: builder.query<ApiResponse<DailyTipContent>, void>({
      query: () => '/content/daily-tip',
      providesTags: [ContentTagType.DAILY_TIP],
    }),
    getCalculatedMatrix: builder.query<ArcanaContent[] | null, void>({
      query: () => '/content/calc/all',
      transformResponse: extractData,
      providesTags: [ContentTagType.MATRIX],
    }),
    getMatrixByStoneId: builder.query<ArcanaContent[] | null, string>({
      query: (stoneId: string) => `content/calc/${stoneId}`,
      transformResponse: (response: ApiResponse<ArcanaContent[]>): ArcanaContent[] | null => {
        if (Array.isArray(response.data)) {
          return response.data.sort((a, b) => a.cellIndex - b.cellIndex);
        }
        return null;
      },
      providesTags: [ContentTagType.MATRIX],
    }),
  }),
});

export const {
  useGetRandomCardsContentQuery,
  useGetCalculatedMatrixQuery,
  useGetMatrixByStoneIdQuery,
} = contentApi;
